import type { NavigateFunction } from 'react-router-dom';
import { setError } from './storage';

type ApiErrorLike = {
    response?: { data?: { message?: string } };
};

export function getApiErrorMessage(error: unknown, fallback = 'UNKNOWN_ERROR'): string {
    const message = (error as ApiErrorLike)?.response?.data?.message;
    return typeof message === 'string' ? message : fallback;
}

export function handleApiError(
    error: unknown,
    navigate?: NavigateFunction,
    { fallback = 'UNKNOWN_ERROR', redirect = true } = {}
) {
    const message = getApiErrorMessage(error, fallback);
    setError(message);
    if (redirect && navigate) {
        const code = message.replace(/^error/i, '');
        navigate(`/error?errorCode=error${code}`);
    }
}
